'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CmsSection = exports.mapStateToProps = exports.CmsSectionUnwrapped = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _device = require('redux/modules/device');

var _CmsModules = require('containers/CmsPage/CmsModules');

var _CmsHeading = require('components/CmsPage/modules/CmsHeading/CmsHeading');

var _CmsText = require('components/CmsPage/modules/CmsText/CmsText');

var _Section = require('components/Section/Section');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HEIGHTS = ['auto', 'full-screen'];
var HORIZONTAL_POSITIONS = ['left', 'center', 'right'];
var THEMES = ['white', 'light', 'brand', 'dark', 'black'];
var VERTICAL_POSITIONS = ['top', 'middle', 'bottom'];
var WIDTHS = ['auto', 'phone', 'tablet', 'desktop'];

var CmsSectionUnwrapped = exports.CmsSectionUnwrapped = function CmsSectionUnwrapped(_ref) {
  var _classNames;

  var backgroundImage = _ref.backgroundImage,
      cmsModuleId = _ref.cmsModuleId,
      copy = _ref.copy,
      height = _ref.height,
      horizontalPosition = _ref.horizontalPosition,
      modules = _ref.modules,
      theme = _ref.theme,
      title = _ref.title,
      verticalPosition = _ref.verticalPosition,
      width = _ref.width;

  var sectionClasses = (0, _classnames2.default)((_classNames = {
    CmsSection: true
  }, (0, _defineProperty3.default)(_classNames, 'CmsSection--height-' + height, HEIGHTS.includes(height)), (0, _defineProperty3.default)(_classNames, 'CmsSection--horizontal-position-' + horizontalPosition, HORIZONTAL_POSITIONS.includes(horizontalPosition)), (0, _defineProperty3.default)(_classNames, 'CmsSection--theme-' + theme, THEMES.includes(theme)), (0, _defineProperty3.default)(_classNames, 'CmsSection--vertical-position-' + verticalPosition, VERTICAL_POSITIONS.includes(verticalPosition)), (0, _defineProperty3.default)(_classNames, 'CmsSection--width-' + width, WIDTHS.includes(width)), _classNames));

  var style = backgroundImage ? { backgroundImage: 'url(' + backgroundImage + ')' } : null;

  return _react2.default.createElement(
    _Section.Section,
    {
      className: sectionClasses,
      style: style
    },
    _react2.default.createElement(
      'div',
      { className: 'CmsSection__content' },
      _react2.default.createElement(_CmsHeading.CmsHeading, { title: title }),
      _react2.default.createElement(_CmsText.CmsText, { content: copy, cmsModuleId: 'Section:Copy:' + cmsModuleId }),
      _react2.default.createElement(_CmsModules.CmsModules, { modules: modules })
    )
  );
};

CmsSectionUnwrapped.propTypes = {
  backgroundImage: _propTypes2.default.string,
  cmsModuleId: _propTypes2.default.string.isRequired,
  copy: _propTypes2.default.string,
  height: _propTypes2.default.string,
  horizontalPosition: _propTypes2.default.string,
  modules: _propTypes2.default.arrayOf(_CmsModules.CmsModuleShape),
  theme: _propTypes2.default.string,
  title: _propTypes2.default.string,
  verticalPosition: _propTypes2.default.string,
  width: _propTypes2.default.string
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, props) {
  return {
    backgroundImage: (0, _device.selectIsMobile)(state) ? props.imageMobile : props.imageDesktop
  };
};

var CmsSection = exports.CmsSection = (0, _reactRedux.connect)(mapStateToProps)(CmsSectionUnwrapped);